import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SEO from "@/components/SEO";
import { Reveal, Kicker } from "@/components/Reveal";
import { FinalCTA } from "@/pages/Home";
import { api } from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <SEO
        title="FAQ | Hari Om Trading Co. — Tahliwal, Una"
        description="Frequently asked questions about products, model enquiries, quotations, location and opening hours at Hari Om Trading Co., Tahliwal."
        jsonLd={faqs.length ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        } : undefined}
      />
      <section className="grain bg-[#111111] bg-grid-dark py-16 lg:py-24" data-testid="faq-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <Kicker dark>FAQ</Kicker>
            <h1 className="mt-4 font-heading text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              Frequently Asked Questions
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#F6F7F8] py-16 lg:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={f.id} value={f.id} className="border border-[#D9DDE3] bg-white px-6" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="min-h-[44px] py-5 text-left font-heading text-lg font-semibold text-[#161616] hover:text-[#8a6800] hover:no-underline" data-testid={`faq-question-${i}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-[15px] leading-relaxed text-[#667085]" data-testid={`faq-answer-${i}`}>
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
